var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Vue, Component, Prop, Watch } from "vue-facing-decorator";
import { UserCompanyAccessQuery, GetSystemAccessViewPaginatedQuery, SystemPermissionsClient, SitesClient, PaginatedEnumerableOfSystemAccessQueryModel, CreateUserSystemAccessCommand, DeleteUserSystemAccessCommand, GetSiteListQuery, UserSystemAccessModel, SystemAuthorizationStatusEnum } from "@/app/api/battery-portal-api";
import { Notifier } from "@/common/utils/notifier";
import { HttpHelper } from "@/app/utils/http-helper";
const accessClient = new SystemPermissionsClient(window.apiUrl);
const siteClient = new SitesClient(window.apiUrl);
let UserSystemAccessVue = class UserSystemAccessVue extends Vue {
    constructor() {
        super(...arguments);
        // simpletons
        this.working = false;
        this.searchAttempted = false;
        this.sites = [];
        this.systemStatusOptions = [
            { value: SystemAuthorizationStatusEnum.All, text: "All systems" },
            { value: SystemAuthorizationStatusEnum.Authorized, text: "Authorized" },
            { value: SystemAuthorizationStatusEnum.Unauthorized, text: "Unauthorized" }
        ];
        // models
        this.query = new GetSystemAccessViewPaginatedQuery({
            userId: 0,
            companyId: 0,
            siteId: null,
            authorizationStatus: SystemAuthorizationStatusEnum.All,
            pageNo: 1,
            pageSize: 100,
            includeDeleted: false,
            keywords: null
        });
        this.data = new PaginatedEnumerableOfSystemAccessQueryModel();
    }
    created() {
        this.bindQuery();
    }
    ;
    getSites() {
        siteClient
            .getListPOST(new GetSiteListQuery({ companyId: this.filter.companyId, includeDeleted: false }))
            .then(response => {
            this.sites = response;
        })
            .catch((ex) => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        });
    }
    bindQuery() {
        this.query.companyId = this.filter.companyId;
        this.query.userId = this.filter.userId;
        this.query.siteId = this.filter.siteId;
        this.query.authorizationStatus = SystemAuthorizationStatusEnum.All;
        this.query.pageNo = 1;
        this.query.pageSize = 20;
        this.search();
        this.getSites();
    }
    ;
    // get
    search() {
        if (!this.filter || !this.filter.companyId)
            return;
        accessClient
            .search(this.query)
            .then(response => {
            this.data = new PaginatedEnumerableOfSystemAccessQueryModel();
            if (!response)
                return;
            this.data = response;
            this.query.pageNo = this.data.displayedPage;
            this.query.pageSize = this.data.pageSize;
        })
            .catch((ex) => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.searchAttempted = true;
        });
    }
    ;
    // set
    grant(item) {
        if (this.working)
            return;
        if (this.working)
            return;
        this.working = true;
        accessClient
            .add(this.filter.userId, new CreateUserSystemAccessCommand({ requestModel: new UserSystemAccessModel({ userId: this.filter.userId, systemId: item.systemId, companyId: item.companyId, siteId: this.filter.siteId, filterQuery: null }) }))
            .then(() => {
            item.hasAccessToSystem = true;
            Notifier.onOk();
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
        });
    }
    ;
    revoke(item) {
        if (this.working)
            return;
        this.working = true;
        accessClient
            .delete(this.filter.userId, new DeleteUserSystemAccessCommand({ requestModel: new UserSystemAccessModel({ userId: this.filter.userId, systemId: item.systemId, companyId: item.companyId, siteId: this.filter.siteId, filterQuery: null }) }))
            .then(() => {
            item.hasAccessToSystem = false;
            Notifier.onOk();
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
        });
    }
    ;
    // parent component hooks
    finished() {
        this.$emit("systemsUpdated", true);
    }
    ;
    // computed
    get title() {
        if (!this.filter)
            return "";
        return `Authorized Systems ${this.filter.companyName ? " - " + this.filter.companyName : ""}`;
    }
    ;
    get noData() {
        return this.searchAttempted && (!this.data || !this.data.records || !this.data.records.length);
    }
    ;
    hasSystemsToGrant() {
        var systems = this.data.records || [];
        return systems.findIndex(system => system.hasAccessToSystem == false && system.hasAccessToCompanySystems == false) >= 0;
    }
    hasSystemsToRevoke() {
        var systems = this.data.records || [];
        return systems.findIndex(system => system.hasAccessToSystem && !system.hasAccessToCompanySystems) >= 0;
    }
    grantAll() {
        this.working = true;
        accessClient
            .add(this.filter.userId, new CreateUserSystemAccessCommand({ requestModel: new UserSystemAccessModel({ userId: this.filter.userId, systemId: 0, companyId: this.filter.companyId, siteId: this.filter.siteId, filterQuery: this.query }) }))
            .then(() => {
            this.search();
            Notifier.onOk();
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
        });
    }
    revokeAll() {
        this.working = true;
        accessClient
            .delete(this.filter.userId, new DeleteUserSystemAccessCommand({ requestModel: new UserSystemAccessModel({ userId: this.filter.userId, systemId: 0, companyId: this.filter.companyId, siteId: this.filter.siteId, filterQuery: this.query }) }))
            .then(() => {
            this.search();
            Notifier.onOk();
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
        });
    }
    get siteOptions() {
        let sites = (this.sites || []).map(item => {
            return {
                value: item.siteId,
                text: item.siteName || ""
            };
        });
        sites = [{ value: null, text: `All sites` }].concat(sites);
        return sites;
    }
    get siteId() {
        return this.siteOptions.filter(item => {
            return item.value == this.query.siteId;
        })[0] || null;
    }
    ;
    set siteId(item) {
        if (!item)
            return;
        this.query.siteId = item.value;
    }
    ;
    get systemStatus() {
        return this.systemStatusOptions.filter(item => {
            return item.value == this.query.authorizationStatus;
        })[0] || this.systemStatusOptions[0];
    }
    ;
    set systemStatus(item) {
        if (!item)
            return;
        this.query.authorizationStatus = item.value;
    }
    ;
    get showSiteFilter() {
        var _a;
        ((_a = this.filter) === null || _a === void 0 ? void 0 : _a.siteId) == null;
    }
};
__decorate([
    Prop(),
    __metadata("design:type", Boolean)
], UserSystemAccessVue.prototype, "watcher", void 0);
__decorate([
    Prop(),
    __metadata("design:type", typeof (_a = typeof UserCompanyAccessQuery !== "undefined" && UserCompanyAccessQuery) === "function" ? _a : Object)
], UserSystemAccessVue.prototype, "filter", void 0);
__decorate([
    Watch("filter.companyId"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], UserSystemAccessVue.prototype, "bindQuery", null);
__decorate([
    Watch("query.pageNo"),
    Watch("query.pageSize"),
    Watch("query.siteId"),
    Watch("query.authorizationStatus"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], UserSystemAccessVue.prototype, "search", null);
UserSystemAccessVue = __decorate([
    Component({
        name: "UserSystemAccessVue",
        emits: ['systemsUpdated']
    })
], UserSystemAccessVue);
export default UserSystemAccessVue;
